export default __webpack_public_path__ + "static/media/10.7629c7ed.jpg";